export default interface DropdownData<T, U> {
    key: T;
    value: U;
}
